import { createMemoryHistory, createRouter, createWebHistory } from 'vue-router'
import { type RouterOptions } from 'vue-router'
import Auth from '@/views/auth/routes'
import LandingView from '@/views/LandingView.vue'
import Config from '@/utils/config'
import { auth } from '@/router/middleware/Auth'

export const createAppRouter = () => createRouter({
  history: Config.ssr
    ? createMemoryHistory(import.meta.env.BASE_URL)
    : createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/:locale(.{2})?',
      children: [
        {
          // Public and server-rendered: omitting `ssr: false` is what lets
          // App.vue render the shell for crawlers.
          path: '',
          name: 'home',
          component: LandingView,
        },
        {
          // Public and server-rendered, like `home`: legal pages must be
          // reachable and indexable without an account.
          path: 'impressum',
          name: 'imprint',
          component: () => import('@/views/legal/Imprint.vue'),
        },
        {
          path: 'datenschutz',
          name: 'privacy',
          component: () => import('@/views/legal/Privacy.vue'),
        },
        {
          path: 'kontakt',
          name: 'contact',
          component: () => import('@/views/ContactView.vue'),
        },
        {
          path: 'dashboard',
          name: 'dashboard',
          component: () => import('@/views/HomeView.vue'),
          meta: { middleware: [auth()], ssr: false },
        },
        {
          path: 'account/create',
          name: 'account.create',
          component: () => import('@/views/accounts/Create.vue'),
          meta: { middleware: [auth()], ssr: false },
        },
        {
          path: 'account/settings',
          name: 'account.settings',
          component: () => import('@/views/accounts/Settings.vue'),
          meta: { middleware: [auth()], ssr: false },
        },
        {
          path: 'assets',
          name: 'asset.list',
          component: () => import('@/views/assets/List.vue'),
          meta: { middleware: [auth()], ssr: false },
        },
        {
          path: 'asset/create',
          name: 'asset.create',
          component: () => import('@/views/assets/Create.vue'),
          meta: { middleware: [auth()], ssr: false },
        },
        {
          path: 'asset/:id/edit',
          name: 'asset.edit',
          component: () => import('@/views/assets/Create.vue'),
          meta: { middleware: [auth()], ssr: false },
        },
        {
          // Sign-in and registration are not search results.
          path: 'auth',
          meta: { noIndex: true },
          children: Auth,
        },
        {
          path: 'campaigns',
          name: 'campaign.list',
          component: () => import('@/views/campaigns/List.vue'),
          meta: { middleware: [auth()], ssr: false },
        },
        {
          path: 'campaign/create',
          name: 'campaign.create',
          component: () => import('@/views/campaigns/Create.vue'),
          meta: { middleware: [auth()], ssr: false },
        },
        {
          path: 'campaign/:id/edit',
          name: 'campaign.edit',
          component: () => import('@/views/campaigns/Create.vue'),
          meta: { middleware: [auth()], ssr: false },
        },
      ],
    },
  ],
  scrollBehavior: (to, from, savedPosition) => {
    const scrollContainer = document.querySelector('.scroll-container');
    if (!scrollContainer) return savedPosition ?? { left: 0, top: 0 }

    if (savedPosition) {
      scrollContainer.scrollTo(savedPosition)
      return false
    }

    if (to.hash && document) {
      const el = document.getElementById(to.hash.slice(1))
      if (el) {
        el.scrollIntoView()
        return false
      }
    }

    if (to.name !== 'dashboard') {
      scrollContainer.scrollTo({ left: 0, top: 0 })
    }

    return false
  },
} as RouterOptions)
